import LocalStorage from './LocalStorage'
import _ from 'lodash'

/*
    For Feedback system. It internally uses localStorage.
*/


class Feedback {
    static addToVoted(articleId, dateModified) {
        const feedbackList = LocalStorage.get('feedback', 'feedbackList');
        const tempList = JSON.parse(feedbackList);
        if(feedbackList === null){
            LocalStorage.set('feedback', 'feedbackList', JSON.stringify({[articleId]: {dateModified: dateModified}}));
        }else{
            const newList = {...tempList, [articleId]: {dateModified: dateModified}};
            LocalStorage.set('feedback', 'feedbackList', JSON.stringify(newList));
        }
    }

    static isVoteable(articleId, dateModified){
        const feedbackList = JSON.parse(LocalStorage.get('feedback', 'feedbackList'));

        if(feedbackList === null) return true;
        if(!(articleId in feedbackList)) return true
        if(feedbackList[articleId].dateModified !== dateModified) return true

        return false

    }
}

export default Feedback;



// WEBPACK FOOTER //
// ./lib/LocalStorage/Feedback.js